import { TAdminAdminsResponse } from '@mybonum/api';

import { TAdminType } from '../types.ts';

export const normalizeData = (data: TAdminAdminsResponse['result']): TAdminType[] =>
    data.map((item) => ({
        id: item.id,
        email: item.email,
        role: item.role as TAdminType['role'],
    }));
